import Tab from './Tab';

Tab.install = function(Vue) {
  Vue.component(Tab.name, Tab);
};

export default Tab;
